// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--3zRp0","moreText":"styles-module--moreText--3cml5"};